import { useEffect, useState } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

import { ObtenerVersion } from '../connections/auth/AuthConnection';

export const DialogNuevaVersion = () => {

    const [open, setOpen] = useState( false );

    const handleActualizar = () => {

        window.location.reload();

    }

    useEffect(() => {

        async function Obtener(){

            await ObtenerVersion().then( response => {

                if( response?.success && response.version !== process.env.REACT_APP_VERSION ){
                    setOpen( true );
                }

            });

        }

        Obtener();

    }, [ ] );

    return (
        <>
            <Dialog open={ open } onClose={ () => {} } >

                <DialogTitle>
                    Hay una nueva versión del sistema
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        Es necesario actualizar esta pestaña para continuar con la versión más reciente
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ handleActualizar }
                    >
                        Actualizar
                    </Button>

                </DialogActions>

            </Dialog>
        </>
    );
}
